import { motion } from "framer-motion";
import { ArrowUpRight, Radio } from "lucide-react";
import { WhatsAppIcon, DiscordIcon } from "@/components/BrandIcons";

const contacts = [
  {
    name: "WhatsApp Contact",
    label: "+62 858-9114-4895",
    href: "https://wa.me/6285891144895",
    icon: WhatsAppIcon,
    testid: "contact-whatsapp",
  },
  {
    name: "Discord Community",
    label: "discord.gg/EKKKXxmMzv",
    href: "https://discord.gg/EKKKXxmMzv",
    icon: DiscordIcon,
    testid: "contact-discord",
  },
  {
    name: "WhatsApp Community",
    label: "whatsapp.com/channel/0029Vb8vH4X96H4KCXm7Nl37",
    href: "https://whatsapp.com/channel/0029Vb8vH4X96H4KCXm7Nl37",
    icon: Radio,
    testid: "contact-wa-community",
  },
];

export default function Contact() {
  return (
    <section data-testid="contact-page" className="mx-auto flex min-h-screen max-w-3xl flex-col justify-center px-6 pb-24 pt-32">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <h1
          data-testid="contact-title"
          className="font-display text-3xl font-bold tracking-[0.15em] text-emerald-300 text-glow-emerald md:text-4xl"
        >
          CONTACT INFORMATION
        </h1>
        <p
          data-testid="contact-subtitle"
          className="mt-4 text-xs font-semibold tracking-[0.3em] text-emerald-100/60 md:text-sm"
        >
          REACH TEAMJAV ANYTIME, 24/7
        </p>
        <div className="mx-auto mt-4 h-px w-16 bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
      </motion.div>

      <div className="mt-12 flex flex-col gap-5">
        {contacts.map((c, i) => (
          <motion.a
            key={c.testid}
            href={c.href}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.15 + i * 0.12 }}
            data-testid={c.testid}
            className="glass-card group flex items-center gap-5 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:border-emerald-300/40 hover:shadow-[0_0_40px_rgba(52,211,153,0.2)]"
          >
            <div
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-emerald-400 text-[#032117]"
              style={{ boxShadow: "0 0 25px rgba(52,211,153,0.45)" }}
            >
              <c.icon size={26} />
            </div>
            <div className="min-w-0 flex-1 text-left">
              <h3 className="font-display text-lg font-bold tracking-wider text-emerald-100">{c.name}</h3>
              <p className="truncate text-sm font-medium text-emerald-100/50">{c.label}</p>
            </div>
            <ArrowUpRight
              size={22}
              className="shrink-0 text-emerald-300/50 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-emerald-300"
            />
          </motion.a>
        ))}
      </div>
    </section>
  );
}
